import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getRoles } from 'src/api/roles';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends SelectProps<number> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { ...restProps } = props;

    const [options, setOptions] = useState<{ label: string; value: number }[]>([]);

    useRequest(() => getRoles(), {
        onSuccess: (res) => {
            setOptions(
                res.data?.map((item) => {
                    return {
                        label: item.name!,
                        value: item.id!,
                    };
                }) || []
            );
        },
    });

    return (
        <Select
            options={options}
            showSearch
            filterOption={(input, option) =>
                ((option?.label as string) ?? '').toLowerCase().includes(input.toLowerCase())
            }
            placeholder={/* 请选择 */UdeskLocales['current'].components.roleSelect.index.pleaseSelect}
            {...restProps}
        />
    );
});

export default Template;
